import UsersController from './users.controller';
import usersTemplate from './users.html';
import UsersNewController from './new/new.controller';
import usersNewTemplate from './new/new.html';
import UsersFormController from './form/users-form.controller';
import usersFormTemplate from './form/users-form.html';

export default [
	{
		path:         '/users',
		template:     usersTemplate,
		controller:   UsersController,
		controllerAs: '$ctrl',
		title:        'menu.admin-users',
	},
	{
		path:         '/users/form/:kid?',
		template:     usersFormTemplate,
		controller:   UsersFormController,
		controllerAs: '$ctrl',
		title:        'menu.admin-users',
	},
	{
		path:         '/users/new',
		template:     usersNewTemplate,
		controller:   UsersNewController,
		controllerAs: '$ctrl',
		title:        'menu.admin-users',
	}
];
